<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RD8Cu3/tc-custom/9781439617960.jpg?1679091106395" alt="This image is the cover for the book Hockey in Providence, Images of Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hockey in Providence, Images of Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>Providence has an old and rich hockey tradition. The Providence Reds were one of the first professional hockey teams in the United States. In their 51-year history (1926�1977), the Reds won seven playoff championships, including four Calder Cup titles. The Reds were the first minor-league hockey team to operate for 50 seasons. The Providence Bruins, established in the 1992�1993 season, carry on the city�s great hockey legacy and gave Providence its fifth Calder Cup title. Several Hockey Hall of Famers have played for Providence-based teams, including Bobby Bauer, Hector �Toe� Blake, Johnny Bower, Frank Brimsek, Eddie Giacomin, Rod Langway, Milt Schmidt, and Lorne �Gump� Worsley.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Mancuso
      </h2>
      
      <p class="authorDescription body article">Jim Mancuso is a member of the Society for International Hockey Research and the Rhode Island Reds Heritage Society. He has written several other books on minor-league hockey, including Hockey in the Capital District, Hockey in Charlotte, Hockey in Springfield, and Hockey in Syracuse.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?349608cd